import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Footer(props) {
  const { searchText, uploadedOrders, numberOfOrder } = props;
  const [originalOrders, setOriginalOrders] = useState();
  useEffect(() => {
    setOriginalOrders(uploadedOrders);
  }, []);

  const handleClick = (event) => {
    props.searchText(originalOrders);
  };

  return (
    <tfoot>
      <tr center="right">
        <td colSpan={2}></td>
        <td colSpan={1}>
          <button
            onClick={handleClick}
            type="button"
            className="btn btn-outline-secondary"
          >
            Reset
          </button>
        </td>
      </tr>
    </tfoot>
  );
}
export default Footer;
